import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import {
  getVendorInformationByNumber,
  updateForecastReplenishByVendorAndDc
} from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";

class LookupVendorInformationByNumber extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.item) {
      var item = this.state.lookup.item;
      getVendorInformationByNumber(item).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        var data = [];

        if (res.data.success) {
          data = res.data.data;
        } else {
          data = false;
          this.setErrorMessage("Nothing found.");
        }
        this.setState({ data });
        this.setState({
          header: [
            {
              label: "Vendor",
              name: "vendor",
              value: data === false ? " " : data.vendor
            },
            {
              label: "Vendor Name",
              name: "vendName",
              value: data === false ? " " : data.vendName
            },
            {
              label: "Master",
              name: "VMASTER",
              value: data === false ? " " : data.VMASTER
            },
            {
              label: "Vendor Name",
              name: "masterVendor",
              value: data === false ? " " : data.masterVendor
            },
            {
              label: "AP Ref",
              name: "apRefNo",
              value: data === false ? " " : data.apRefNo
            },
            {
              label: "UPC",
              name: "upcNumber",
              value: data === false ? " " : data.upcNumber
            },
            {
              label: "Fax Number",
              name: "faxNumber",
              value: data === false ? " " : data.faxNumber
            },
            {
              label: "Customer Service",
              name: "phoneNumber",
              value: data === false ? " " : data.phoneNumber
            },
            {
              label: "Intl Fax",
              name: "intFaxNumber",
              value: data === false ? " " : data.intFaxNumber
            }
          ],
          cards: [
            {
              "Mailing Address": [
                {
                  name: "mailName",
                  label: data === false ? "." : data.mailName
                },
                {
                  name: "mailAddress",
                  label: data === false ? "." : data.mailAddress
                },
                {
                  name: "mailCity",
                  label: data === false ? "." : data.mailCity
                }
              ]
            },
            {
              "Shipping Address": [
                {
                  name: "shipName",
                  label: data === false ? "." : data.shipName
                },
                {
                  name: "shipAddress",
                  label: data === false ? "." : data.shipAddress
                },
                {
                  name: "shipCity",
                  label: data === false ? "." : data.shipCity
                }
              ]
            },
            {
              Card3: [
                {
                  label: "Vendor Group",
                  name: "vendorGroup",
                  value: data === false ? " " : data.vendorGroup
                },
                {
                  label: "",
                  name: "ContactName",
                  value: data === false ? " " : data.ContactName
                },
                {
                  label: "",
                  name: "ContactPhone",
                  value: data === false ? " " : data.ContactPhone
                },
                {
                  label: "",
                  name: "ContactTitle",
                  value: data === false ? " " : data.ContactTitle
                },
                {
                  name: "contact1Name",
                  label: data === false ? "." : data.contact1Name
                },
                {
                  name: "contact1Phone",
                  label: data === false ? "." : data.contact1Phone
                },
                {
                  name: "contact1TitleText",
                  label: data === false ? "." : data.contact1TitleText
                },
                {
                  name: "contact2Name",
                  label: data === false ? "." : data.contact2Name
                },
                {
                  name: "contact2Phone",
                  label: data === false ? "." : data.contact2Phone
                },
                {
                  name: "contact2TitleText",
                  label: data === false ? "." : data.contact2TitleText
                },
                {
                  name: "contact3Name",
                  label: data === false ? "." : data.contact3Name
                },
                {
                  name: "contact3Phone",
                  label: data === false ? "." : data.contact3Phone
                },
                {
                  name: "contact3TitleText",
                  label: data === false ? "." : data.contact3TitleText
                }
              ]
            },
            {
              Card4: [
                {
                  label: "EP Returns",
                  name: "epReturns",
                  value: data === false ? " " : data.epReturns
                },
                {
                  label: "VDP Days",
                  name: "vendorDirectDays",
                  value: data === false ? " " : data.vendorDirectDays
                },
                {
                  label: "Cutoff Time",
                  name: "vdpCutOffTime",
                  value: data === false ? " " : data.vdpCutOffTime
                },
                {
                  label: "Last Pull Time",
                  name: "vdpVendPullTime",
                  value: data === false ? " " : data.vdpVendPullTime
                },
                {
                  label: "VDP Freight Code",
                  name: "vdpFreight",
                  value: data === false ? " " : data.vdpFreight
                },
                {
                  label: "Start Date",
                  name: "vdpStartDate",
                  value: data === false ? " " : data.vdpStartDate
                },
                {
                  label: "Timezone",
                  name: "vdpVendTimeZone",
                  value: data === false ? " " : data.vdpVendTimeZone
                },
                {
                  label: "VDP Run Schedule",
                  name: "VDPRunSchedule",
                  value: data === false ? " " : data.VDPRunSchedule
                },
                {
                  label: "undefined",
                  name: "vdpAM07",
                  value: data === false ? " " : data.vdpAM07
                },
                {
                  label: "undefined",
                  name: "vdpAM08",
                  value: data === false ? " " : data.vdpAM08
                },
                {
                  label: "undefined",
                  name: "vdpAM09",
                  value: data === false ? " " : data.vdpAM09
                },
                {
                  label: "undefined",
                  name: "vdpAM10",
                  value: data === false ? " " : data.vdpAM10
                },
                {
                  label: "undefined",
                  name: "vdpAM11",
                  value: data === false ? " " : data.vdpAM11
                },
                {
                  label: "undefined",
                  name: "vdpPM12",
                  value: data === false ? " " : data.vdpPM12
                },
                {
                  label: "undefined",
                  name: "vdpPM01",
                  value: data === false ? " " : data.vdpPM01
                },
                {
                  label: "undefined",
                  name: "vdpPM02",
                  value: data === false ? " " : data.vdpPM02
                },
                {
                  label: "undefined",
                  name: "vdpPM03",
                  value: data === false ? " " : data.vdpPM03
                },
                {
                  label: "undefined",
                  name: "vdpPM04",
                  value: data === false ? " " : data.vdpPM04
                },
                {
                  label: "undefined",
                  name: "vdpPM05",
                  value: data === false ? " " : data.vdpPM05
                },
                {
                  label: "undefined",
                  name: "vdpPM06",
                  value: data === false ? " " : data.vdpPM06
                },
                {
                  label: "undefined",
                  name: "vdpPM07",
                  value: !data ? " " : data.vdpPM07
                },
                {
                  label: "undefined",
                  name: "vdpPM08",
                  value: !data ? " " : data.vdpPM08
                },
                {
                  label: "undefined",
                  name: "vdpPM09",
                  value: !data ? " " : data.vdpPM09
                },
                {
                  label: "undefined",
                  name: "vdpPM10",
                  value: !data ? " " : data.vdpPM10
                },
                {
                  label: "Auto Cancel DSD",
                  name: "dsdAutoCancel",
                  value: !data ? " " : data.dsdAutoCancel
                },
                {
                  label: "undefined",
                  name: "dsdAutoCancelDays",
                  value: !data ? " " : data.dsdAutoCancelDays
                },
                {
                  label: "Code of Conduct",
                  name: "codeConductDate",
                  value: !data ? " " : data.codeConductDate
                },
                {
                  label: "PM",
                  name: "designated",
                  value: !data ? " " : data.designated
                },
                {
                  label: "Date Agreement Signed",
                  name: "agreementSignDate",
                  value: !data ? " " : data.agreementSignDate
                },
                {
                  label: "Mail Order",
                  name: "mailOrder",
                  value: !data ? " " : data.mailOrder
                },
                {
                  label: "Order Method",
                  name: "orderMethod",
                  value: !data ? " " : data.orderMethod
                },
                {
                  label: "Ship Method",
                  name: "shipMethod",
                  value: !data ? " " : data.shipMethod
                },
                {
                  label: "Forecast Year",
                  name: "forecastPeriods",
                  value: !data ? " " : data.forecastPeriods
                },
                {
                  label: "Forecast Length",
                  name: "forecastLength",
                  value: !data ? " " : data.forecastLength
                },
                {
                  label: "Forecast Type",
                  name: "forecastType",
                  value: !data ? " " : data.forecastType
                },
                {
                  label: "Forecast Display",
                  name: "forecastDisp",
                  value: !data ? " " : data.forecastDisp
                },
                {
                  label: "Forecast Pad",
                  name: "forecastPad",
                  value: !data ? " " : data.forecastPad
                },
                {
                  label: "Forecast Net Inv",
                  name: "forecastNet",
                  value: !data ? " " : data.forecastNet
                },
                {
                  label: "Forecast File",
                  name: "forecastFile",
                  value: !data ? " " : data.forecastFile
                },
                {
                  label: "Forecast New Items",
                  name: "forecastNewItems",
                  value: !data ? " " : data.forecastNewItems
                },
                {
                  label: "SCAC Code",
                  name: "vendScacCode",
                  value: !data ? " " : data.vendScacCode
                },
                {
                  label: "POS Flag",
                  name: "posFlag",
                  value: !data ? " " : data.posFlag
                },
                {
                  label: "FRR",
                  name: "rightReturnFlag",
                  value: !data ? " " : data.rightReturnFlag
                }
              ]
            }
          ]
        });
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please input a vendor number");
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.vendor
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      // this.checkHotChanges();
    }
  };

  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }
  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Vendor Information by Number
        </h3>
        <div
          style={{
            transform: "scaleY(.8855)",
            overflow: "hidden",
            transformOrigin: "top"
          }}
        >
          <HeaderLayout
            setHeaderInfo={this.getHeaderInfo}
            setErrorMessage={this.setErrorMessage}
            setSuccessMessage={this.setSuccessMessage}
            lookup={this.lookup}
            headerData={this.state.header}
          />
          <CardsLayout
            style={{ transformOrigin: "top", transform: "scaleY(.5)" }}
            cardsData={this.state.cards}
            setCardsInfo={this.getCardsInfo}
          />
        </div>

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
            <Link to="/" className="sub-menu-item-tag">
              <Button bsStyle="warning" className="btn-sm" disabled={false}>
                Close
              </Button>
            </Link>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
      </div>
    );
  }
}
export default LookupVendorInformationByNumber;
